// extracted by mini-css-extract-plugin
module.exports = {"self":"Reactions_self__8r0p6"};